module.exports = __webpack_public_path__ + "static/media/Board of Studies_2025-26.b383aed2.pdf";